<template>
  <g
    id="ic_doubleUp"
    transform="translate(-182 -132)"
  >
    <rect
      id="Rechteck_817"
      data-name="Rechteck 817"
      width="24"
      height="24"
      transform="translate(182 132)"
      fill="none"
    />
    <path
      id="Pfad_1562"
      data-name="Pfad 1562"
      d="M25.506,41.667,31.64,33.33l-6.134-8.38H20.625l6,8.38-6,8.337Zm8.985,0,6.134-8.337-6.134-8.38H29.61l6,8.38-6,8.337Z"
      transform="translate(160.75 174.625) rotate(-90)"
      fill="#455667"
    />
  </g>
</template>
